import useAuth from '../../../../hooks/useAuth'
import {useEffect, useState, FC, useRef} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {i18n} from '../../../../translate/i18n'
import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import {ContentModalDescriptionIA} from '../../../../components/ContentModalDescriptionIA'
import {Loading} from '../../../../components/Loading/Loading'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {Input} from '../../../../components/Input/Input'
import usePluginSpace from '../../../../hooks/usePluginSpace'

import {DELETE, GET, POST, PUT} from '../../../../services/api'
import {Button} from '../../../../components/Button/Button'
import ReactLoading from 'react-loading'
import styles from './newCreate.module.css'
import {IndexGrade} from '../../../../components/Modals/Variacoes/Grade/indexGrade'
import {EditVariacao} from '../../../../components/Modals/Variacoes/Variacao/editVariacao'
import uuid from 'react-uuid'
import {EditorQuill} from '../../../../components/EditorQuill/EditorQuill'
import {Notification} from '../../../../components/Notification/Notification'

import Swal from 'sweetalert2'
import {Product} from './interfaces/editProduct'
import usePluginsSpace from '../../../../hooks/usePluginSpace'

type ReturnType = {
  id: string
  parent: string
  code: string
  name: string
  description: string
  value: string
  select: string
  shortname: string
  order: string
}

type PluginconfigType = {
  id: number
  name: string
  content: any
  plugintemplateId: number
  plugintypeId: number
}

type TemplateType = {
  id: number
  name: string
  image: string | null
  parameters: string
  plugintypeId: number
  pluginconfig: PluginconfigType
  typeIntegration: string
  able: boolean | null
}

type GridTypeResponse = {
  id: number
  name: string
  variation: string
  status?: boolean
  variationId?: number
}
interface FileWithPreview extends File {
  preview: string
  id: string | number
}

type LocationTypeResponse = {
  id: number
  name: string
  type?: string
  code: string
}

type SelectType = {
  value: string | number
  label: string
}

interface CustomerGroup {
  id: number
  pluginspaceId: number
  name: string
  created: string
  updated: string | null
  deleted: string | null
}

interface GroupResponseData {
  id: string
  pluginspaceId: number
  productId: number
  customerGroupId: number
  createdAt: string | null
  deletedAt: string | null
  customerGroup: CustomerGroup
}

type ImageType = {
  id: number
  productId: string
  order: number
  path: string
  imgsuffix: string
  typeimg: string
}

const NewEditarProdutosContent: FC = () => {
  const {loginInfo} = useAuth()
  const {id} = useParams()
  const navigate = useNavigate()
  const {hasERP} = usePluginsSpace()
  const {getPluginSpace} = usePluginSpace()
  const [loading, setLoading] = useState(false)
  const [, setCanAlert] = useState(false)
  const [pluginIA, setPluginIA] = useState('')
  const [showDescriptionIAModal, setShowDescriptionIAModal] = useState(false)
  const [loadingDescIA, setLoadingDescIA] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  // Estados para grupos de clientes (atacado)
  const [isWholeSaler, setIsWholeSaler] = useState(false)
  const [groups, setGroups] = useState<
    {
      created: string
      deleted: string
      id: number
      name: string
      pluginspaceId: number
      updated: string
    }[]
  >([])
  const [groupsAssociated, setGroupsAssociated] = useState<SelectType[]>([])

  const [name, setName] = useState<string>('')
  const [description, setDescription] = useState<string>('')
  const [technicalSpecification, setTechnicalSpecification] = useState<string>('')
  const [subcategoryId, setSubcategoryId] = useState<string>('0')
  const [markId, setMarkId] = useState<string>('0')
  const [code, setCode] = useState<string>('0')
  const [measurementId, setMeasurementId] = useState<string>('0')
  const [status, setStatus] = useState<boolean>(true)
  const [order, setOrder] = useState<number>(0)
  const [filesMedidas, setFilesMedidas] = useState<File[] | ImageType[]>([])
  const [filesProduto, setFilesProduto] = useState<File[] | ImageType[]>([])
  /**Usado para remover arquivos já existentes no banco */
  const [filesProdutoToDelete, setFilesProdutoToDelete] = useState<ImageType[]>([])

  const [weight] = useState<number>()
  const [height] = useState<number>()
  const [width] = useState<number>()
  const [deep] = useState<number>()
  const [formatSize, setFormatSize] = useState<string>('square')

  const [grids, setGrids] = useState<GridTypeResponse[]>([])
  const [gradeSelected, setGradeSelected] = useState<{variationId: number; variations: string[]}[]>(
    []
  )

  const [locations, setLocations] = useState<any[]>([])
  const [locationsSelected, setLocationsSelected] = useState<string | null>(null)

  const [isSimpleProduct, setIsSimpleProduct] = useState<boolean>(true)
  const [isVariationProduct, setIsVariationProduct] = useState<boolean>(false)
  const [categories, setCategories] = useState<any[]>([])
  const [listClassification] = useState<any[]>([])
  const [marks, setMarks] = useState<any[]>([])
  const [measurements, setMeasurements] = useState<any[]>([])
  const [stockQuantity] = useState<number>()

  const [showEditVariacao, setShowEditVariacao] = useState(false)
  const [variacaoSelecionada, setVariacaoSelecionada] = useState<any>(null)

  const [variacoesTabela, setVariacoesTabela] = useState<any[]>([])
  const [variacoesComErro, setVariacoesComErro] = useState<string[]>([])

  // Variáveis para adicionar novos valores às grades existentes
  const [showVariacoesModal, setShowVariacoesModal] = useState(false)
  const [editGradeAgain, setEditGradeAgain] = useState(false)
  const [, setSelectedGradeToEdit] = useState<number | null>(null)
  const [alarm, setAlarm] = useState(false)
  const [canAlarmDescription, setCanAlarmDescription] = useState(false)

  const gridsRef = useRef<GridTypeResponse[]>([])

  const [notification, setNotification] = useState<{
    message: string
    type: 'success' | 'error'
    show: boolean
  }>({
    message: '',
    type: 'success',
    show: false,
  })

  const generateClassificationTree = (
    categories: ReturnType[],
    parent: string | null,
    name: string,
    code: string
  ): any => {
    const parentCategory = categories.find((category) => category.code === parent)
    if (parentCategory)
      return `${generateClassificationTree(
        categories,
        parentCategory.parent,
        parentCategory.name,
        parentCategory.code
      )} > [${code}] ${name}`
    else return `[${code}] ${name}`
  }

  const getCategories = async () => {
    try {
      const res = await GET(`/classification`)
      // Categorias por order
      // Validar, está incorreot
      const sortedCategories = res.data.sort((a: ReturnType, b: ReturnType) => {
        const orderA = parseInt(a.order || '0')
        const orderB = parseInt(b.order || '0')
        return orderA - orderB
      })

      sortedCategories.forEach((row: ReturnType) => {
        listClassification.push({
          id: row.id,
          parent: row.parent,
          code: row.code,
          name: generateClassificationTree(sortedCategories, row.parent, row.name, row.code),
        })
      })

      const categories = [
        {
          value: '0',
          select: 'Selecione',
          key: -1,
        },
      ]
      listClassification.forEach((row: any, idx) => {
        categories.push({
          value: row.id,
          select: row.name,
          key: idx,
        })
      })
      setCategories(categories)
      await getProduct(categories)
    } catch (e) {
      console.log(e)
    }
  }

  const getMarks = async () => {
    try {
      const res = await GET('/mark')
      const marks = [
        {
          value: '0',
          select: 'Selecione',
        },
      ]
      res.data
        .sort((a: ReturnType, b: ReturnType) => a.name.localeCompare(b.name))
        .forEach((row: ReturnType) => {
          marks.push({
            value: row.id,
            select: row.name,
          })
        })
      setMarks(marks)
    } catch (e) {
      console.log(e)
    }
  }

  const getMeasurements = async () => {
    try {
      const res = await GET('/measurement')
      const measurements = [
        {
          value: '0',
          select: 'Selecione',
        },
      ]
      res.data
        .sort((a: ReturnType, b: ReturnType) => a.shortname.localeCompare(b.shortname))
        .forEach((row: ReturnType) => {
          measurements.push({
            value: row.id,
            select: row.description,
          })
        })
      setMeasurements(measurements)
    } catch (e) {
      console.log(e)
    }
  }

  const getCustomersGroups = async () => {
    try {
      const thisPluginsSpace = await getPluginSpace(true)
      const isWholeSaler = thisPluginsSpace && thisPluginsSpace.wholeSaler

      if (isWholeSaler) {
        setIsWholeSaler(true)
        const res = await GET('/customer_groups')
        if (res && res.data) {
          setGroups(res.data)
        }

        // Buscar grupos já associados ao produto
        if (id) {
          const groupsAssociated = await GET(`/product-customer-group/${id}/product`)
          if (groupsAssociated && groupsAssociated.data) {
            const groupData: GroupResponseData[] = groupsAssociated.data
            setGroupsAssociated(
              groupData.map((item) => ({
                value: item.customerGroup.id,
                label: item.customerGroup.name,
              }))
            )
          }
        }
      }
    } catch (error) {
      console.log('Erro ao buscar grupos de clientes:', error)
    }
  }

  const verifyIA = async () => {
    const templateRes = await GET('/plugintemplate/ia')
    if (templateRes && templateRes.data) {
      templateRes.data.forEach((template: TemplateType) => {
        if (template.pluginconfig) {
          if (
            template.pluginconfig.content &&
            template.pluginconfig.content.able &&
            template.pluginconfig.content.able !== '0'
          ) {
            setPluginIA(template.pluginconfig.content.modelId)
          }
        }
      })
    }
  }

  const generateDescriptionIA = async () => {
    setLoadingDescIA(true)
    try {
      if (pluginIA) {
        const result = await POST('structure-correction-ia/converse-structure', {
          prompt:
            description === ''
              ? `Crie a descrição do produto com base no nome que estou passando. Segue o nome: ${name}`
              : `Corrija ou melhore a descrição do produto que estou passando. Segue a descrição: ${description}`,
          modelId: pluginIA,
          systemPrompt: description === '' ? 'Criar o texto' : 'Revisar o texto',
          typeCorrectionStructure:
            description === '' ? 'description-structure' : 'revision-structure',
        })
        if (result && result.message && result.message.data) {
          setDescription(result.message.data)
          setCanAlert(true)
        }
      }
    } catch (e) {
      console.log('Erro ao chamar API IA (Descrição):', e)
    } finally {
      setLoadingDescIA(false)
    }
  }

  const getGrids = async () => {
    try {
      const gridRes = await GET('/grid')
      const newGrids: GridTypeResponse[] = []
      gridRes.data.forEach((grid: GridTypeResponse) => {
        grid.status &&
          newGrids.push({
            id: grid.id,
            name: grid.name,
            variation: grid.variation,
          })
      })
      setGrids(newGrids)
      gridsRef.current = newGrids
    } catch (e) {
      console.log(e)
    }
  }

  const getLocations = async () => {
    try {
      const locationRes = await GET('/location')
      let newLocations: any[] = []

      let selectedLocationId: string | null = null

      locationRes.data.forEach((location: LocationTypeResponse) => {
        if (location.type !== 'address') {
          newLocations.push({
            value: location.id,
            select: location.name,
          })
        }
        if (location.type !== 'address' && location.code === 'withdraw')
          selectedLocationId = location.id.toString()
      })
      setLocations(newLocations)

      if (selectedLocationId) setLocationsSelected(selectedLocationId)
    } catch (e) {
      console.log(e)
    }
  }

  // Função para identificar o tipo de grade
  const identifyGradeType = (gradeName: string): 'color' | 'size' | 'unknown' => {
    const colorKeywords = ['cor', 'coloração', 'cores', 'tonalidade', 'color', 'colours', 'colors']
    const sizeKeywords = ['tam', 'tamanho', 'tamanhou', 'size', 'sizes', 'tamanhos']

    const normalizedName = gradeName.toLowerCase().trim()

    // Verifica se o nome contém alguma palavra-chave de cor
    if (colorKeywords.some((keyword) => normalizedName.includes(keyword))) {
      return 'color'
    }

    // Verifica se o nome contém alguma palavra-chave de tamanho
    if (sizeKeywords.some((keyword) => normalizedName.includes(keyword))) {
      return 'size'
    }

    return 'unknown'
  }

  // Função para propagar imagem para variações da mesma cor
  const propagateImageToColorVariations = async (
    image: string,
    colorName: string,
    variations: any[],
    gradeSelected: {variationId: number; variations: string[]}[]
  ) => {
    // Encontra a grade de cor
    const colorGrade = gradeSelected.find(
      (grade) => identifyGradeType(findNameGrade(grade) || '') === 'color'
    )
    if (!colorGrade) return false

    // Encontra a grade de tamanho
    const sizeGrade = gradeSelected.find(
      (grade) => identifyGradeType(findNameGrade(grade) || '') === 'size'
    )
    if (!sizeGrade) return false

    // Filtra as variações que pertencem à mesma cor
    // const colorVariations = variations.filter((variation) => {
    //   const colorValue = variation.context.find(
    //     (ctx: any) => ctx.cod_desc === findNameGrade(colorGrade)
    //   )?.value
    //   return colorValue === colorName
    // })

    // Atualiza as imagens das variações da mesma cor
    const updatedVariations = variations.map((variation) => {
      const colorValue = variation.context.find(
        (ctx: any) => ctx.cod_desc === findNameGrade(colorGrade)
      )?.value

      if (colorValue === colorName) {
        return {
          ...variation,
          img: image,
        }
      }
      return variation
    })

    return updatedVariations
  }

  const findNameGrade = (itemSelected: any) => {
    return grids.find((grade) => grade.id === itemSelected.variationId)?.name
  }

  const processImageWithAPI = async (file: File, width: number, height: number) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('width', width.toString())
      formData.append('height', height.toString())

      const response = await POST('product/process-image_v2', formData)

      if (response.success) {
        const base64String = response.data.file.image

        // Remove o prefixo 'data:image/jpeg;base64,'
        const base64Data = base64String.replace(/^data:image\/\w+;base64,/, '')
        const byteCharacters = atob(base64Data)
        const byteNumbers = new Array(byteCharacters.length)
          .fill(0)
          .map((_, i) => byteCharacters.charCodeAt(i))
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], {type: response.data.file.type})

        return new File([blob], response.data.file.name, {type: response.data.file.type})
      } else {
        throw new Error(response.error || 'Erro ao processar imagem')
      }
    } catch (error) {
      console.error('Erro ao processar imagem:', error)
      throw error
    }
  }

  const verifyImages = async (filesToVerify: File[] | ImageType[]) => {
    const processedFiles: FileWithPreview[] = []
    const requiredWidth = formatSize === 'square' ? 640 : 600
    const requiredHeight = formatSize === 'square' ? 640 : 900

    for (const file of filesToVerify) {
      try {
        if (!('preview' in file)) {
          continue
        }

        const processedFile = await processImageWithAPI(file as File, requiredWidth, requiredHeight)
        processedFiles.push(
          Object.assign(processedFile, {
            preview: URL.createObjectURL(processedFile),
            id: uuid(),
          })
        )
      } catch (error) {
        console.error('Erro ao processar imagem:', error)
      }
    }

    return processedFiles || filesToVerify
  }

  function limparHTML(html: string): string {
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = html
    return tempDiv.textContent || ''
  }

  const generateSKU = () => {
    const possible = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'
    let text = ''
    for (let i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length))
    }
    text += Date.now().toString().slice(-4)
    return text
  }

  const uploadImgGuide = async (img: any) => {
    try {
      if (img.length <= 0) return null

      const formData = new FormData()
      formData.append('file', img[0])
      formData.append('nameImage', `guide-${uuid()}.jpg`)
      const imgRes = await POST('/upload-images/upload-one', formData)

      return imgRes
    } catch (error) {
      return {
        success: false,
        image: '',
      }
    }
  }

  // Função para atualizar as imagens principais (imgsmall, mainpicture, thumbpicture)
  const updateMainImageTypes = async (productId: number, imagePath: string) => {
    try {
      const mainImageTypes = ['imgsmall', 'mainpicture', 'thumbpicture']

      // Busca imagens principais existentes
      const existingImagesRes = await POST(`/productimage/filter`, {
        productId: productId,
      })

      if (existingImagesRes.success) {
        const mainImages = existingImagesRes.data.filter((img: any) =>
          mainImageTypes.includes(img.typeimg)
        )

        // Atualiza cada tipo de imagem principal
        await Promise.all(
          mainImageTypes.map(async (type) => {
            const existingImage = mainImages.find((img: any) => img.typeimg === type)

            if (existingImage) {
              return PUT(`/productimage/${existingImage.id}`, {
                imgsuffix: imagePath,
                order: 0,
              })
            } else {
              return POST('/productimage', {
                imgsuffix: imagePath,
                productId: productId,
                typeimg: type,
                order: 0,
              })
            }
          })
        )
      }
    } catch (error) {
      console.error('Erro ao atualizar imagens principais:', error)
    }
  }

  const editProduct = async () => {
    const subcategorySelected: any = subcategoryId
    try {
      // eslint-disable-next-line eqeqeq
      if (!name || subcategoryId == '0' || !limparHTML(description)) {
        setCanAlert(true)
        setAlarm(true)
        setCanAlarmDescription(true)
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos!',
        })
        return
      } else {
        setAlarm(false)
        setCanAlarmDescription(false)
        setLoading(true)

        const technical_specificationLength = limparHTML(technicalSpecification).length
        const descriptionLength = limparHTML(description).length

        const data = {
          name: name,
          description: descriptionLength ? description : null,
          order: order,
          code: code ?? '',
          classificationId: parseInt(subcategorySelected.value),
          type: 'product',
          status: status,
          measurementUnitId: measurementId !== '0' ? parseInt(measurementId) : null,
          parent: '',
          markId: parseInt(markId) ? parseInt(markId) : null,
          technicalSpecification: technical_specificationLength ? technicalSpecification : null,
        }

        const resProd = await PUT(`/product/${id}`, data)

        if (resProd.success === true) {
          // Gerenciar guia de medidas
          let imageGuide = {success: false, image: ''}

          // Buscar imagem de guia existente
          const existingGuideRes = await POST(`/productimage/filter`, {
            productId: Number(id),
          })

          const existingGuideImage = existingGuideRes.success
            ? existingGuideRes.data.find((img: any) => img.typeimg === 'guide')
            : null

          // Se tem nova imagem de guia para upload
          if (filesMedidas.length > 0 && filesMedidas[0] instanceof File) {
            // Delete imagem de guia existente se houver
            if (existingGuideImage) {
              await DELETE(`/productimage/${existingGuideImage.id}`)
            }

            // Upload nova imagem de guia
            imageGuide = await uploadImgGuide(filesMedidas)
          } else if (filesMedidas.length === 0 && existingGuideImage) {
            // Se não tem imagem no estado mas existe no banco, significa que foi removida
            await DELETE(`/productimage/${existingGuideImage.id}`)
          }

          let firstImagePath = ''
          let newImagesData: any[] = []

          // Processa todas as imagens do produto respeitando a ordem do array filesProduto
          if (filesProduto.length > 0) {
            for (let i = 0; i < filesProduto.length; i++) {
              const image = filesProduto[i]

              if ('id' in image && !('preview' in image)) {
                // Imagem existente - apenas atualiza a ordem
                const existingImage = image as ImageType
                await PUT(`/productimage/${existingImage.id}`, {
                  order: i,
                })

                // Se é a primeira imagem, usa seu path para imagens principais
                if (i === 0) {
                  firstImagePath = existingImage.imgsuffix
                }
              } else {
                // Imagem nova - faz upload
                const processedFiles = await verifyImages([image as File])
                if (processedFiles.length > 0) {
                  const formData = new FormData()
                  formData.append('file', processedFiles[0])
                  formData.append('nameImage', `product-${uuid()}.jpg`)
                  const imageRes = await POST('/upload-images/upload-one', formData)

                  if (imageRes.success) {
                    newImagesData.push({
                      path: imageRes.image,
                      productId: resProd.dados.id,
                      typeimg: 'image',
                      order: i,
                    })

                    // Se é a primeira imagem, usa seu path para imagens principais
                    if (i === 0) {
                      firstImagePath = imageRes.image
                    }
                  }
                }
              }
            }
          }

          // Adiciona imagem guia se houver uma nova
          if (imageGuide?.success === true) {
            newImagesData.push({
              path: imageGuide.image,
              productId: resProd.dados.id,
              typeimg: 'guide',
              order: 0,
            })
          }

          // Salva apenas as novas imagens no banco
          if (newImagesData.length > 0) {
            await POST('/productimage/multiple', {data: newImagesData})
          }

          // Remove imagens marcadas para deleção
          if (filesProdutoToDelete.length > 0) {
            await Promise.all(
              filesProdutoToDelete.map(async (image) => {
                if ('id' in image) {
                  await DELETE(`/productimage/${image.id}`)
                }
              })
            )
            // Limpa o array de imagens para deletar
            setFilesProdutoToDelete([])
          }

          // Atualiza as imagens principais para apontar para a primeira imagem
          if (firstImagePath) {
            await updateMainImageTypes(resProd.dados.id, firstImagePath)
          }

          // Salvar grupos de clientes se for atacado
          if (isWholeSaler) {
            await POST('/product-customer-group', {
              productId: id,
              customerGroups: groupsAssociated.map((group) => group.value),
            })
          }

          setCanAlert(false)

          // Se é produto simples, navega diretamente
          if (isSimpleProduct) {
            Swal.fire({
              icon: 'success',
              title: 'Produto editado',
              text: 'Produto editado com sucesso!',
            }).then(() => {
              navigate(loginInfo.plugintype === 'varejo' ? '/product_varejo' : '/product_fashion')
            })
          }
          // Se tem variações, a navegação será feita em updateExistingVariations
        } else {
          setCanAlert(true)
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao cadastrar o produto!',
          })
        }
      }
    } catch (e) {
      setCanAlert(true)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao editar o produto!',
      })
    } finally {
      setLoading(false)
    }
  }

  const checkVariations = async () => {
    try {
      const variacoesErro: string[] = []
      variacoesTabela.forEach((variation: any) => {
        if (!variation.locationId || !variation.sku || !variation.price) {
          variacoesErro.push(variation.id)
        }
      })
      setVariacoesComErro(variacoesErro)

      if (variacoesErro.length > 0) {
        Swal.fire({
          icon: 'error',
          title: 'Campos faltantes',
          text: 'Verifique se preencheu todos os campos obrigatórios nas variações!',
        })
        return
      }

      // Para edição, primeiro atualiza o produto
      await editProduct()

      // Separar variações existentes (ID numérico) das novas (ID UUID)
      const existingVariations = variacoesTabela.filter((v) => !isNaN(Number(v.id)))
      const newVariations = variacoesTabela.filter((v) => isNaN(Number(v.id)))

      // Atualizar variações existentes
      if (existingVariations.length > 0) {
        await updateExistingVariations()
      }

      // Criar novas variações (novos valores adicionados às grades)
      if (newVariations.length > 0) {
        await createVariation(id as string)
      }

      // Se só tem variações existentes, navega aqui
      if (newVariations.length === 0) {
        await Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Produto e variações atualizados com sucesso.',
        })
        navigate(loginInfo.plugintype === 'varejo' ? '/product_varejo' : '/product_fashion')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const createVariation = async (productId: string) => {
    try {
      setLoading(true)

      // Filtrar apenas as novas variações (IDs UUID)
      const newVariations = variacoesTabela.filter((v) => isNaN(Number(v.id)))

      // Adiciona o productId em cada variação nova
      const variacoesComProductId = newVariations.map(({id, ...rest}) => ({
        ...rest,
        productId: Number(productId),
        locationId: Number(rest.locationId),
        price:
          typeof rest.price === 'string'
            ? parseFloat(rest.price.replace(/[R$\s.]/g, '').replace(',', '.'))
            : rest.price,
        costPrice: rest.costPrice
          ? typeof rest.costPrice === 'string'
            ? parseFloat(rest.costPrice.replace(/[R$\s.]/g, '').replace(',', '.'))
            : rest.costPrice
          : 0,
        promotionalPrice: rest.promotionalPrice
          ? typeof rest.promotionalPrice === 'string'
            ? parseFloat(rest.promotionalPrice.replace(/[R$\s.]/g, '').replace(',', '.'))
            : rest.promotionalPrice
          : 0,
        inventory: Number(rest.inventory),
        minimumStock: rest.minimumStock ? Number(rest.minimumStock) : 0,
        width: rest.width ? Number(rest.width) : 0,
        height: rest.height ? Number(rest.height) : 0,
        weight: rest.weight ? Number(rest.weight) : 0,
        depth: rest.depth ? Number(rest.depth) : 0,
        status: Boolean(rest.status),
        stockSituation: rest.productAvailability ? Number(rest.productAvailability) : null,
        outOfStockSituation: rest.productOutOfStock ? Number(rest.productOutOfStock) : null,
        context: JSON.stringify(
          rest.context.reduce((acc: any, item: {cod_desc: string; value: any}) => {
            acc[item.cod_desc] =
              typeof item.value === 'object' && item.value !== null ? item.value.value : item.value
            return acc
          }, {})
        ),
        img: rest.img ? rest.img : '',
      }))

      if (variacoesComProductId.length === 0) {
        return {success: true}
      }

      const variationsRes = await POST('/variations/multiple', {
        data: variacoesComProductId,
      })

      if (variationsRes.success === true) {
        const res = await saveImgVariations(variacoesComProductId, variationsRes)
        if (res) {
          setCanAlert(false)
          await Swal.fire({
            icon: 'success',
            title: 'Produtos cadastrados',
            text: 'Novas variações criadas com sucesso!',
          })

          navigate(loginInfo.plugintype === 'varejo' ? '/product_varejo' : '/product_fashion')
        } else {
          console.log(res)
          setCanAlert(true)
          await Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Erro ao salvar imagens das variações!',
          })
        }
      } else {
        setCanAlert(true)
        await Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Erro ao cadastrar as novas variações!',
        })
      }
    } catch (e) {
      setCanAlert(true)
      await Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao cadastrar as novas variações!',
      })
    } finally {
      setLoading(false)
    }
  }

  const saveImgVariations = async (variacoesComProductId: any, variationsRes: any) => {
    try {
      setLoading(true)
      await Promise.all(
        variacoesComProductId.map(async (variacao: any, index: any) => {
          if (variacao.img) {
            const variationId = variationsRes.dados.identifiers[index].id
            await PUT(`/variations/${variationId}`, {
              img: variacao.img,
            })
          }
        })
      )
      return {success: true}
    } catch (error) {
      console.error('Erro ao salvar imagens de variações:', error)
      return {success: false, error}
    }
  }

  const updateExistingVariations = async () => {
    try {
      setLoading(true)

      // Atualizar variações existentes
      const updatePromises = variacoesTabela.map(async (variation) => {
        // Se o ID é numérico, é uma variação existente que precisa ser atualizada
        if (!isNaN(Number(variation.id))) {
          const updateData = {
            locationId: Number(variation.locationId),
            price:
              typeof variation.price === 'string'
                ? parseFloat(variation.price.replace(/[R$\s.]/g, '').replace(',', '.'))
                : variation.price,
            costPrice: variation.costPrice
              ? typeof variation.costPrice === 'string'
                ? parseFloat(variation.costPrice.replace(/[R$\s.]/g, '').replace(',', '.'))
                : variation.costPrice
              : 0,
            promotionalPrice: variation.promotionalPrice
              ? typeof variation.promotionalPrice === 'string'
                ? parseFloat(variation.promotionalPrice.replace(/[R$\s.]/g, '').replace(',', '.'))
                : variation.promotionalPrice
              : 0,
            inventory: Number(variation.inventory),
            minimumStock: variation.minimumStock ? Number(variation.minimumStock) : 0,
            width: variation.width ? Number(variation.width) : 0,
            height: variation.height ? Number(variation.height) : 0,
            weight: variation.weight ? Number(variation.weight) : 0,
            depth: variation.depth ? Number(variation.depth) : 0,
            status: Boolean(variation.status),
            stockSituation: variation.productAvailability
              ? Number(variation.productAvailability)
              : null,
            outOfStockSituation: variation.productOutOfStock
              ? Number(variation.productOutOfStock)
              : null,
            sku: variation.sku,
            referenceCode: variation.referenceCode || '',
            gtin: variation.gtin || '',
            mpn: variation.mpn || '',
            ncm: variation.ncm || '',
            img: variation.img || '',
          }

          return PUT(`/variations/${variation.id}`, updateData)
        }
        return null
      })

      await Promise.all(updatePromises.filter((promise) => promise !== null))

      setCanAlert(false)
      return {success: true}
    } catch (error) {
      setCanAlert(true)
      await Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Erro ao atualizar as variações!',
      })
      return {success: false}
    } finally {
      setLoading(false)
    }
  }

  const getProduct = async (categories: any[]) => {
    try {
      const productRes = await GET(`/product/with-all-variations/${id}`)

      if (productRes && productRes.success) {
        const data: Product = productRes.data[0]

        // Informações básicas do produto
        setName(data.name || '')
        setDescription(data.description || '')
        setTechnicalSpecification(data.technicalSpecification || '')

        setCode(data.code || '')

        setMarkId(data.markId ? data.markId.toString() : '0')
        setMeasurementId(data.measurementUnitId ? data.measurementUnitId.toString() : '0')
        setStatus(data.status !== undefined ? data.status : true)
        setOrder(data.order || 0)

        const selectedCategory: any = categories.find(
          (category) => category.value === data.classificationId.toString()
        )
        const aux: any = {
          value: selectedCategory ? selectedCategory.value : '0',
          label: selectedCategory ? selectedCategory.select : 'Selecione',
        }
        setSubcategoryId(aux)

        // Imagens do produto
        if (data.images && data.images.length > 0) {
          // Separar imagens por tipo
          const productImages = data.images.filter(
            (img) => img.typeimg === 'mainpicture' || img.typeimg === 'image'
          )
          const guideImages = data.images.filter((img) => img.typeimg === 'guide')

          // Converter URLs para objetos File se necessário
          // Este é um exemplo, você pode precisar ajustar baseado na estrutura real da API
          if (productImages.length > 0) {
            const images: ImageType[] = productImages.map((img) => ({
              id: img.id,
              productId: img.productId.toString(),
              order: img.order || 0,
              path: img.path,
              imgsuffix: img.imgsuffix,
              typeimg: img.typeimg,
            }))

            setFilesProduto(images.sort((a, b) => a.order - b.order))
          }

          if (guideImages.length > 0) {
            const images: ImageType[] = guideImages.map((img) => ({
              id: img.id,
              productId: img.productId.toString(),
              order: img.order || 0,
              path: img.path,
              imgsuffix: img.imgsuffix,
              typeimg: img.typeimg,
            }))

            setFilesMedidas(images)
          }
        }

        // Processar variações do produto que já vêm no objeto
        if (data.variations && data.variations.length > 0) {
          // Se tem variações, define como produto com variações
          setIsSimpleProduct(false)
          setIsVariationProduct(true)

          // Processa as variações existentes
          const existingVariations = data.variations.map((variation: any) => {
            // Parse do context que vem como string JSON
            let contextObj = {}
            try {
              contextObj =
                typeof variation.context === 'string'
                  ? JSON.parse(variation.context)
                  : variation.context || {}
            } catch (e) {
              console.error('Erro ao fazer parse do context:', e)
            }

            // Converte o context object de volta para o formato esperado
            const contextArray = Object.entries(contextObj).map(([key, value]) => ({
              cod_desc: key,
              value: value,
            }))

            return {
              id: variation.id.toString(),
              name: contextArray.map((ctx: any) => ctx.value).join(' '),
              context: contextArray,
              inventory: variation.inventory || 0,
              price: variation.price || 0,
              costPrice: variation.costPrice || 0,
              promotionalPrice: variation.promotionalPrice || 0,
              height: variation.height || 0,
              width: variation.width || 0,
              depth: variation.depth || 0,
              weight: variation.weight || 0,
              minimumStock: variation.minimumStock || '',
              productAvailability: variation.stockSituation || '',
              productOutOfStock: variation.outOfStockSituation || '',
              locationId: variation.locationId ? variation.locationId.toString() : '',
              sku: variation.sku || '',
              referenceCode: variation.referenceCode || '',
              gtin: variation.gtin || '',
              mpn: variation.mpn || '',
              ncm: variation.ncm || '',
              status: variation.status !== undefined ? variation.status : true,
              img: variation.img || '',
            }
          })

          setVariacoesTabela(existingVariations)

          // Extrair e definir as grades utilizadas
          await extractGradesFromVariations(existingVariations)
        } else {
          // Se não tem variações, define como produto simples
          setIsSimpleProduct(true)
          setIsVariationProduct(false)
          setVariacoesTabela([])
          setGradeSelected([])
        }
      }
    } catch (e) {
      console.log('Erro ao buscar produto:', e)
      setNotification({
        message: 'Erro ao carregar os dados do produto',
        type: 'error',
        show: true,
      })
    }
  }

  const extractGradesFromVariations = async (variations: any[]) => {
    if (variations.length === 0) return

    // Coletar todos os cod_desc únicos das variações
    const uniqueGrades = new Set<string>()
    variations.forEach((variation) => {
      variation.context.forEach((ctx: any) => {
        uniqueGrades.add(ctx.cod_desc)
      })
    })

    // Encontrar os IDs das grades baseado nos nomes
    const selectedGrades: {variationId: number; variations: string[]}[] = []

    const gradeNamesArray = Array.from(uniqueGrades)
    for (const gradeName of gradeNamesArray) {
      const gradeData = gridsRef.current.find((grid) => grid.name === gradeName)
      if (gradeData) {
        // Coletar todas as variações únicas desta grade
        const gradeVariations = new Set<string>()
        variations.forEach((variation) => {
          const contextItem = variation.context.find((ctx: any) => ctx.cod_desc === gradeName)
          if (contextItem) {
            gradeVariations.add(contextItem.value)
          }
        })

        selectedGrades.push({
          variationId: gradeData.id,
          variations: Array.from(gradeVariations),
        })
      }
    }

    setGradeSelected(selectedGrades)
  }

  const init = async () => {
    setLoading(true)
    await getGrids()
    await verifyIA()
    await getCategories()
    await getMarks()
    await getMeasurements()
    await getLocations()
    await getCustomersGroups()
    await getCategories()
    setLoading(false)
  }

  useEffect(() => {
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Função removida: handleRemoveVariation - não permitimos mais remover variações de grades na edição

  // Função para criar as combinações de variações (mantida para referência)
  function createVariations(arrays: string[][]): string[][] {
    return arrays.reduce(
      (a, b) => a.map((x) => b.map((y) => x.concat([y]))).reduce((a, b) => a.concat(b), []),
      [[]] as string[][]
    )
  }

  // UseEffect para adicionar novas variações quando novos valores são adicionados às grades
  useEffect(() => {
    if (gradeSelected.length > 0 && !loading) {
      const variationsArrays = gradeSelected.map((grade) => grade.variations)
      const combinations = createVariations(variationsArrays)
      const nomesGrades = gradeSelected.map((grade) => findNameGrade(grade))

      setVariacoesTabela((prevVariacoesTabela) => {
        // Criar mapa das variações existentes para busca rápida
        const existingVariationsMap = new Map()
        prevVariacoesTabela.forEach((variation) => {
          existingVariationsMap.set(variation.name, variation)
        })

        const updatedVariacoes = combinations.map((comb) => {
          const name = comb.join(' ')
          const existingVariation = existingVariationsMap.get(name)

          if (existingVariation) {
            // Se a variação já existe, mantém os dados existentes
            return existingVariation
          } else {
            // Se é uma nova variação, cria com dados padrão
            return {
              id: uuid(),
              name: name,
              context: comb.map((value, index) => ({
                cod_desc: nomesGrades[index],
                value: value,
              })),
              inventory: stockQuantity ? stockQuantity : '0',
              price: 0,
              costPrice: 0,
              promotionalPrice: 0,
              height: height ? height : 0,
              width: width ? width : 0,
              depth: deep ? deep : 0,
              weight: weight ? weight : 0,
              minimumStock: '',
              productAvailability: '',
              productOutOfStock: '',
              locationId: locationsSelected ? locationsSelected : '',
              sku: generateSKU(),
              referenceCode: '',
              gtin: '',
              mpn: '',
              ncm: '',
              status: true,
              img: '',
            }
          }
        })
        return updatedVariacoes
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gradeSelected, stockQuantity, height, width, deep, weight, locationsSelected, loading])

  const handleSaveVariacao = async (variacaoEditada: any, propagateImage: boolean = false) => {
    if (propagateImage && variacaoEditada.img) {
      // Encontra a grade de cor
      const colorGrade = gradeSelected.find(
        (grade) => identifyGradeType(findNameGrade(grade) || '') === 'color'
      )
      if (colorGrade) {
        // Encontra o valor da cor na variação editada
        const colorValue = variacaoEditada.context.find(
          (ctx: any) => ctx.cod_desc === findNameGrade(colorGrade)
        )?.value

        if (colorValue) {
          const updatedVariations = await propagateImageToColorVariations(
            variacaoEditada.img,
            colorValue,
            variacoesTabela,
            gradeSelected
          )

          if (updatedVariations) {
            setVariacoesTabela(updatedVariations)
          }
        }
      }
    }

    setVariacoesTabela((prev) =>
      prev.map((v) => (v.id === variacaoEditada.id ? variacaoEditada : v))
    )
    setNotification({
      message: 'Variação salva com sucesso!',
      type: 'success',
      show: true,
    })
  }

  useEffect(() => {
    if (showEditVariacao || showVariacoesModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showEditVariacao, showVariacoesModal])

  // Função melhorada para deletar imagem de medidas do banco e atualizar estado
  function deleteFileMedidas(imagem: ImageType) {
    DELETE(`/productimage/${imagem.id}`)
      .then(() => {
        // Limpa o estado local após deletar do banco para garantir sincronização
        setFilesMedidas([])
        setNotification({
          message: 'Imagem de medidas removida com sucesso!',
          type: 'success',
          show: true,
        })
      })
      .catch((error) => {
        console.error('Erro ao remover imagem de medidas:', error)
        setNotification({
          message: 'Erro ao remover imagem de medidas.',
          type: 'error',
          show: true,
        })
      })
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className='row g-5 gx-xxl-12 pb-5'>
            <div className='card'>
              <div className='card-header py-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bold fs-4 mb-1'>
                    {i18n.t(`smart_order.create_product`)}
                  </span>
                  <BreadCrumbs />
                </h3>
              </div>
            </div>

            <div className='card mt-8'>
              <div className='px-10 py-5'>
                <h1 className={styles.sectionTitle}>
                  <i className='bi bi-file-earmark-text'></i>
                  Detalhes do Produto
                </h1>
                <div className='mt-8'>
                  {/* Informações do Produto */}
                  <div className={`${styles.groupTitle} mt-1`}>Informações do Produto</div>

                  <Input
                    inputAttr={{
                      type: 'default',
                    }}
                    placeholder={i18n.t(`smart_order.name`)}
                    label={`${i18n.t(`smart_order.name`)} *`}
                    value={name}
                    change={(value: string) => {
                      setCanAlert(true)
                      setName(value)
                    }}
                    alarm={alarm && !name}
                    alarmText='Campo obrigatório'
                    generateValueIA={
                      pluginIA && pluginIA !== ''
                        ? {
                            modelId: pluginIA,
                            prompt:
                              name === ''
                                ? 'Sugira um nome de produto com base na descrição: ' + description
                                : 'Corrija o nome do produto: ' + name,
                            action: name === '' ? 'create' : 'fix',
                          }
                        : undefined
                    }
                  />
                  <div className='mt-6'>
                    <div className={styles.descriptionHeader}>
                      <div className='d-flex align-items-center justify-content-between'>
                        <label className='form-label fw-normal'>
                          {i18n.t(`smart_order.description`)} *
                        </label>
                        {pluginIA && pluginIA !== '' && (
                          <Button
                            text='Descrição Avançada com IA'
                            color='primary'
                            size='small'
                            horizontalPadding={3}
                            svgIcon={
                              <svg
                                width='15'
                                height='15'
                                viewBox='0 0 15 15'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                                  fill='white'
                                />
                              </svg>
                            }
                            btnAttr={{
                              type: 'button',
                            }}
                            click={() => setShowDescriptionIAModal(true)}
                            btnClass='fw-bolder d-flex flex-row gap-1 align-items-center'
                            txtClass='text-nowrap text-white'
                            outline={false}
                            disabled={!name}
                          />
                        )}
                      </div>
                    </div>
                    <EditorQuill
                      change={(value: string) => {
                        setCanAlert(true)
                        setDescription(value)
                      }}
                      value={description}
                      alarm={canAlarmDescription && !limparHTML(description)}
                      maxLength={840}
                    />

                    {/* Botão IA Avançada */}
                    {pluginIA && pluginIA !== '' && (
                      <div className='d-flex justify-content-start mt-2'>
                        <Button
                          text='Descrição Avançada com IA'
                          color='primary'
                          size='small'
                          horizontalPadding={3}
                          svgIcon={
                            <svg
                              width='15'
                              height='15'
                              viewBox='0 0 15 15'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                                fill='white'
                              />
                            </svg>
                          }
                          btnAttr={{
                            type: 'button',
                          }}
                          click={() => setShowDescriptionIAModal(true)}
                          btnClass='fw-bolder d-flex flex-row gap-1 align-items-center'
                          txtClass='text-nowrap text-white'
                          outline={false}
                          disabled={!name}
                        />
                      </div>
                    )}

                    {canAlarmDescription && !limparHTML(description) && (
                      <div className='d-flex align-items-center border-hover-primary rounded w-100 mt-1'>
                        <span
                          style={{
                            color:
                              canAlarmDescription && !limparHTML(description) ? '#d90429' : 'none',
                          }}
                        >
                          Campo obrigatório
                        </span>
                      </div>
                    )}
                    <div className={styles.descriptionFooter}>
                      <div>
                        {pluginIA && pluginIA !== '' && (
                          <div className='d-flex justify-content-start' style={{maxWidth: '100%'}}>
                            {loadingDescIA ? (
                              <ReactLoading type='spin' color='#D5D5D5' height={25} width={25} />
                            ) : (
                              <Button
                                text={`${i18n.t(`buttons.generate_ia`)} descrição`}
                                color='info'
                                size='small'
                                horizontalPadding={5}
                                btnAttr={{
                                  type: 'button',
                                }}
                                svgIcon={
                                  <svg
                                    width='15'
                                    height='15'
                                    viewBox='0 0 15 15'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M6.39844 1.92578L6.78125 0.886719C6.80859 0.804688 6.89062 0.75 7 0.75C7.08203 0.75 7.16406 0.804688 7.19141 0.886719L7.57422 1.92578L8.61328 2.30859C8.69531 2.33594 8.75 2.41797 8.75 2.5C8.75 2.60938 8.69531 2.69141 8.61328 2.71875L7.57422 3.10156L7.19141 4.11328C7.16406 4.19531 7.08203 4.25 7 4.25C6.89062 4.25 6.80859 4.19531 6.78125 4.11328L6.39844 3.10156L5.38672 2.71875C5.30469 2.69141 5.25 2.60938 5.25 2.5C5.25 2.41797 5.30469 2.33594 5.38672 2.30859L6.39844 1.92578ZM12.6055 2.0625L9.59766 5.07031L10.5547 6.02734L13.5625 3.01953L12.6055 2.0625ZM2.1875 12.5078L3.11719 13.4375L9.625 6.95703L8.66797 6L2.1875 12.5078ZM11.6758 1.16016C12.1953 0.640625 13.0156 0.640625 13.5352 1.16016L14.4648 2.08984C14.9844 2.60938 14.9844 3.42969 14.4648 3.94922L4.04688 14.3672C3.52734 14.8867 2.70703 14.8867 2.1875 14.3672L1.25781 13.4375C0.738281 12.918 0.738281 12.0977 1.25781 11.5781L11.6758 1.16016ZM0.191406 3.97656L1.75 3.375L2.32422 1.84375C2.35156 1.70703 2.48828 1.625 2.625 1.625C2.73438 1.625 2.87109 1.70703 2.89844 1.84375L3.5 3.375L5.03125 3.97656C5.16797 4.00391 5.25 4.14062 5.25 4.25C5.25 4.38672 5.16797 4.52344 5.03125 4.55078L3.5 5.125L2.89844 6.68359C2.87109 6.79297 2.73438 6.875 2.625 6.875C2.48828 6.875 2.35156 6.79297 2.32422 6.68359L1.75 5.125L0.191406 4.55078C0.0820312 4.52344 0 4.38672 0 4.25C0 4.14062 0.0820312 4.00391 0.191406 3.97656ZM9.81641 10.9766L11.375 10.375L11.9492 8.84375C11.9766 8.70703 12.1133 8.625 12.25 8.625C12.3594 8.625 12.4961 8.70703 12.5234 8.84375L13.125 10.375L14.6562 10.9766C14.793 11.0039 14.875 11.1406 14.875 11.25C14.875 11.3867 14.793 11.5234 14.6562 11.5508L13.125 12.125L12.5234 13.6836C12.4961 13.793 12.3594 13.875 12.25 13.875C12.1133 13.875 11.9766 13.793 11.9492 13.6836L11.375 12.125L9.81641 11.5508C9.70703 11.5234 9.625 11.3867 9.625 11.25C9.625 11.1406 9.70703 11.0039 9.81641 10.9766Z'
                                      fill='white'
                                    />
                                  </svg>
                                }
                                click={generateDescriptionIA}
                                btnClass='fw-bolder me-3 d-flex flex-row gap-2 align-items-center'
                                txtClass='text-nowrap'
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='mt-6'>
                      <div>
                        <label className='form-label fw-normal'>
                          {i18n.t(`smart_order.technical_specification`)}
                        </label>
                      </div>
                      <EditorQuill
                        change={(value: string) => {
                          setCanAlert(true)
                          setTechnicalSpecification(value)
                        }}
                        value={technicalSpecification}
                        maxLength={415}
                      />

                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        search
                        label={`${i18n.t(`smart_order.category`)} *`}
                        options={categories}
                        value={subcategoryId}
                        change={(value: string) => {
                          setCanAlert(true)
                          setSubcategoryId(value)
                        }}
                        marginTop='mt-0'
                        alarm={alarm && subcategoryId === '0'}
                        alarmText='Campo obrigatório'
                      />
                    </div>
                  </div>

                  <div className='row g-6'>
                    <div className='col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label={`${i18n.t(`smart_order.mark`)}`}
                        options={marks}
                        value={markId}
                        change={(value: string) => {
                          setCanAlert(true)
                          setMarkId(value)
                        }}
                      />
                    </div>
                    <div className='col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label={`${i18n.t(`smart_order.measurement_unit`)}`}
                        options={measurements}
                        value={measurementId}
                        change={(value: string) => {
                          setCanAlert(true)
                          setMeasurementId(value)
                        }}
                      />
                    </div>
                  </div>

                  <div className='row g-6'>
                    <div className='col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'select',
                        }}
                        label='Status'
                        options={[
                          {select: i18n.t(`general.active`), value: true},
                          {select: i18n.t(`general.inactive`), value: false},
                        ]}
                        value={status}
                        change={(value: boolean) => {
                          setCanAlert(true)
                          setStatus(value)
                        }}
                      />
                    </div>
                    <div className='col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder='0'
                        label={i18n.t(`smart_order.order`)}
                        smalltext='(para exibição no webapp)'
                        value={order}
                        change={(value: number) => {
                          setCanAlert(true)
                          setOrder(value)
                        }}
                        alarmText='Campo obrigatório'
                      />
                    </div>
                  </div>

                  <div className='mt-6'>
                    <label className={styles.labelImageGuia}>Guia de Medidas</label>
                    <div className={styles.imageUploadContainer}>
                      <div className={styles.inputWrapper}>
                        <input
                          type='file'
                          accept='image/*'
                          onChange={(e) => {
                            setCanAlert(true)
                            if (e.target.files && e.target.files.length > 0) {
                              setFilesMedidas([e.target.files[0]])
                            }
                          }}
                          className={styles.fileInput}
                        />
                        {filesMedidas && filesMedidas.length > 0 ? (
                          <div className={styles.previewImage}>
                            <img
                              src={
                                filesMedidas[0] instanceof File
                                  ? URL.createObjectURL(filesMedidas[0])
                                  : `${(filesMedidas[0] as ImageType).path}/${
                                      (filesMedidas[0] as ImageType).imgsuffix
                                    }`
                              }
                              alt='Guia de Medidas'
                              className='w-100 h-100'
                              style={{objectFit: 'cover'}}
                            />
                            <button
                              className={styles.deleteImageButton}
                              onClick={(e) => {
                                e.preventDefault()

                                const file = filesMedidas[0]

                                // Verifica se é uma imagem existente (tem id) ou nova (File)
                                if ('id' in file && file.id) {
                                  // Imagem existente - confirma antes de deletar do banco
                                  Swal.fire({
                                    title: 'Atenção!',
                                    text: 'Você tem certeza que deseja excluir a imagem de medidas?',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonText: 'Sim',
                                    cancelButtonText: 'Não',
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      deleteFileMedidas(file as ImageType)
                                    }
                                  })
                                } else {
                                  // Imagem nova - apenas remove do estado
                                  setFilesMedidas([])
                                }
                              }}
                              title='Excluir imagem'
                            >
                              <i className='bi bi-x-lg'></i>
                            </button>
                          </div>
                        ) : (
                          <div className={styles.inputPlaceholder}>
                            <i className='bi bi-card-image'></i>
                            <span>Selecione uma imagem</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Preços */}

                  {/* <div className={`${styles.groupTitle} mt-2 d-none`}>Preços</div>
                  <div className='mt-2 row g-6 d-none'>
                    <div className='mt-0 col-md-4'>
                      <Input
                        inputAttr={{
                          type: 'money',
                        }}
                        currency='BRL'
                        locale='pt-BR'
                        label={i18n.t(`smart_order.cost_price`)}
                        change={(value: number) => {
                          setCanAlert(true)
                          setCostPrice(value)
                        }}
                        value={costPrice}
                        marginTop='mt-0'
                      />
                    </div>
                    <div className='mt-0 col-md-4'>
                      <Input
                        inputAttr={{
                          type: 'money',
                        }}
                        currency='BRL'
                        locale='pt-BR'
                        label={i18n.t(`smart_order.sell_price`)}
                        change={(value: number) => {
                          setCanAlert(true)
                          setPrice(value)
                        }}
                        value={price}
                        marginTop='mt-0'
                      />
                    </div>
                    <div className='mt-0 col-md-4'>
                      <Input
                        inputAttr={{
                          type: 'money',
                        }}
                        currency='BRL'
                        locale='pt-BR'
                        label={i18n.t(`smart_order.promotional_price`)}
                        change={(value: number) => {
                          setCanAlert(true)
                          setPromotionalPrice(value)
                        }}
                        value={promotionalPrice}
                        marginTop='mt-0'
                      />
                    </div>
                  </div> */}

                  {/* Estoque */}

                  {/* <div className={`${styles.groupTitle} mt-6 d-none`}>Estoque</div>
                  <div className={`d-none`}>
                    <div className={`${styles.containerStock}`}>
                      <div className={`d-flex flex-column`}>
                        <div
                          className={`cursor-pointer ${styles.radioItem}`}
                          onClick={() => {
                            setCanAlert(true)
                            setStockType('infinite')
                          }}
                        >
                          <span className={styles.radioLabel}>Infinito</span>
                          <div
                            className={`${styles.radioCircle} ${
                              stockType === 'infinite' ? styles.checked : ''
                            }`}
                          >
                            {stockType === 'infinite' && (
                              <i className={`bi bi-check ${styles.checkIcon}`}></i>
                            )}
                          </div>
                        </div>
                        <div
                          className={`cursor-pointer ${styles.radioItem}`}
                          onClick={() => {
                            setCanAlert(true)
                            setStockType('limited')
                          }}
                        >
                          <span className={styles.radioLabel}>Limitado</span>
                          <div
                            className={`${styles.radioCircle} ${
                              stockType === 'limited' ? styles.checked : ''
                            }`}
                          >
                            {stockType === 'limited' && (
                              <i className={`bi bi-check ${styles.checkIcon}`}></i>
                            )}
                          </div>
                        </div>
                      </div>

                      <div
                        className={`${styles.stockLine} ${
                          stockType === 'limited' ? styles.visible : ''
                        }`}
                      >
                        <Input
                          inputAttr={{
                            type: 'number',
                          }}
                          label='Quantidade'
                          value={stockQuantity}
                          change={(value: number) => {
                            setCanAlert(true)
                            setStockQuantity(value)
                          }}
                          placeholder='0'
                          marginTop='mt-0'
                        />

                        <div
                          className={`${styles.stockAlert} ${
                            stockType === 'limited' ? styles.visible : ''
                          }`}
                        >
                          <i className='bi bi-exclamation-triangle-fill'></i>
                          <span>Estoque somente para produtos com variação</span>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  {/* Volumetria */}

                  {/* <div className={`${styles.groupTitle} mt-6 d-none`}>Volumetria</div>

                  <div className='mt-2 row g-6 d-none'>
                    <div className='mt-0 col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder='0'
                        label={`${i18n.t(`smart_order.weight`)} (Kg)`}
                        change={(value: number) => {
                          setCanAlert(true)
                          setWeight(value)
                        }}
                        value={weight}
                        marginTop='mt-0'
                      />
                    </div>
                    <div className='mt-0 col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder='0'
                        label={`${i18n.t(`smart_order.height`)} (cm)`}
                        change={(value: number) => {
                          setCanAlert(true)
                          setHeight(value)
                        }}
                        value={height}
                        marginTop='mt-0'
                      />
                    </div>
                    <div className='mt-0 col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder='0'
                        label={`${i18n.t(`smart_order.width`)} (cm)`}
                        change={(value: number) => {
                          setCanAlert(true)
                          setWidth(value)
                        }}
                        value={width}
                        marginTop='mt-4'
                      />
                    </div>
                    <div className='mt-0 col-md-6'>
                      <Input
                        inputAttr={{
                          type: 'number',
                        }}
                        placeholder='0'
                        label={`${i18n.t(`smart_order.depth`)} (cm)`}
                        change={(value: number) => {
                          setCanAlert(true)
                          setDeep(value)
                        }}
                        value={deep}
                        marginTop='mt-4'
                      />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            {/* Grupos de Clientes para Atacado */}
            {isWholeSaler && (
              <div className='card mt-8'>
                <div className='px-10 py-5'>
                  <h1 className={styles.sectionTitle}>
                    <i className='bi bi-people'></i>
                    {i18n.t(`smart_order.product_groups`)}
                  </h1>
                  <div className='mt-8'>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      isMulti
                      search
                      placeholder={i18n.t(`smart_order.product_groups`)}
                      label={i18n.t(`smart_order.product_groups`)}
                      value={groupsAssociated}
                      change={(selectedGroups: SelectType[]) => {
                        setCanAlert(true)
                        setGroupsAssociated(selectedGroups)
                      }}
                      options={groups.map((row) => {
                        return {
                          value: row.id,
                          select: row.name,
                        }
                      })}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Imagens do produto */}
            <div className='card mt-8 px-0'>
              <div className='px-10 py-5'>
                <h1 className={`${styles.sectionTitle} mb-0`}>
                  <i className='bi bi-images'></i>
                  Imagem Produto
                </h1>
                <div className='mt-6'>
                  <span>Selecione as dimensões</span>
                  <div className='d-flex align-items-center gap-3 mt-2'>
                    <div
                      className={`${styles.checkboxContainer} ${
                        formatSize === 'square' ? styles.checked : ''
                      }`}
                      onClick={() => {
                        setCanAlert(true)
                        setFormatSize('square')
                      }}
                    >
                      <input
                        type='checkbox'
                        checked={formatSize === 'square'}
                        className={styles.checkboxInput}
                      />
                      <span className={styles.checkboxLabel}>Tratar com 640x640</span>
                    </div>
                    <div
                      className={`${styles.checkboxContainer} ${
                        formatSize === 'rectangle' ? styles.checked : ''
                      }`}
                      onClick={() => {
                        setCanAlert(true)
                        setFormatSize('rectangle')
                      }}
                    >
                      <input
                        type='checkbox'
                        checked={formatSize === 'rectangle'}
                        className={styles.checkboxInput}
                      />
                      <span className={styles.checkboxLabel}>Tratar com 600x900</span>
                    </div>
                  </div>
                </div>
                <div className='mt-8'>
                  <Input
                    inputAttr={{type: 'image-upload-edit'}}
                    label='Imagens Produto'
                    change={(newFiles: File[]) => {
                      setCanAlert(true)
                      setFilesProduto(newFiles)
                    }}
                    setImagesToDelete={setFilesProdutoToDelete}
                    imagesToDelete={filesProdutoToDelete}
                    value={filesProduto}
                    iconImage={'bi bi-images'}
                    mainTextImage={'Arraste e solte sua imagem principal e imagens adicionais'}
                    descriptionImage={
                      'Você pode arrastar e soltar as imagens para organizá-las. A imagem que ficar na primeira posição será considerada como a imagem principal.'
                    }
                    sizeImage={`As Imagens devem ter ${
                      formatSize === 'square' ? '640x640' : '600x900'
                    } para melhor visualização.`}
                    dragAndDropImage={true}
                  />
                </div>
              </div>
            </div>

            <Notification
              message={errorMessage}
              type='warning'
              show={!!errorMessage}
              onClose={() => setErrorMessage('')}
              duration={2000}
            />

            <div className='card mt-8 '>
              <div className='px-10 py-5'>
                <h1 className={styles.sectionTitle}>
                  <i className='bi bi-grid-3x3-gap'></i>
                  Variação Produto
                </h1>
                <div className='mt-8'>
                  {/* Exibir apenas o tipo do produto sem permitir edição */}
                  <div className='alert alert-info d-flex align-items-center gap-3'>
                    <i className='bi bi-info-circle'></i>
                    <div>
                      <strong>Tipo do produto:</strong>{' '}
                      {isSimpleProduct ? 'Produto Simples' : 'Produto com Variação'}
                      {!isSimpleProduct && (
                        <div className='mt-1 text-muted small'>
                          Para alterar o tipo ou estrutura de grades, é necessário criar um novo
                          produto.
                        </div>
                      )}
                    </div>
                  </div>
                  {!isVariationProduct ? (
                    <div className='mt-8'>
                      <p>Este é um produto simples, sem variações.</p>
                      <small>
                        <strong>
                          Para adicionar variações, crie um novo produto do tipo "com variação".
                        </strong>
                        <br />
                        Não é possível transformar um produto simples em produto com variações após
                        sua criação.
                      </small>
                    </div>
                  ) : (
                    <>
                      <div className={`${styles.groupTitle} mt-6`}>
                        Grades utilizadas neste produto
                      </div>

                      {/* Exibir grades existentes com possibilidade de adicionar novos valores */}
                      {gradeSelected.length > 0 && (
                        <div className='mt-4 mb-4'>
                          <div className='alert-light'>
                            {gradeSelected.map((grade, index) => (
                              <div key={grade.variationId} className='mb-3'>
                                <div className='fw-bold mb-2 d-flex justify-content-between align-items-center'>
                                  <span>{findNameGrade(grade)}</span>
                                  {index === 0 && (
                                    <button
                                      type='button'
                                      className='btn btn-sm btn-outline-primary'
                                      onClick={() => {
                                        setEditGradeAgain(false)
                                        setSelectedGradeToEdit(grade.variationId)
                                        setShowVariacoesModal(true)
                                      }}
                                      title={`Adicionar novos valores às grades existentes`}
                                    >
                                      <i className='fas fa-plus me-1'></i>
                                      Adicionar valores
                                    </button>
                                  )}
                                </div>
                                <div className='d-flex flex-wrap gap-2'>
                                  {grade.variations.map((variation) => (
                                    <span key={variation} className={styles.variationChip}>
                                      {variation}
                                    </span>
                                  ))}
                                </div>
                              </div>
                            ))}
                            <div className='mt-6'>
                              <small className='text-muted'>
                                <strong>Permitido:</strong> Adicionar novos valores às grades
                                existentes (ex: nova cor, novo tamanho).
                                <br />
                                <strong>Não permitido:</strong> Alterar a estrutura das grades ou
                                remover valores existentes. Para isso, crie um novo produto.
                              </small>
                            </div>
                          </div>
                        </div>
                      )}
                      {variacoesTabela.length > 0 && (
                        <>
                          <div className={styles.tableContainer}>
                            <table className={`${styles.variationTable}`}>
                              <thead>
                                <tr>
                                  <th>Variação</th>
                                  <th>SKU</th>
                                  <th>Estoque</th>
                                  <th>Preço de venda</th>
                                  <th>Status</th>
                                  <th>Ação</th>
                                </tr>
                              </thead>
                              <tbody>
                                {variacoesTabela.map((item) => (
                                  <tr
                                    key={item.id}
                                    style={{
                                      borderLeft: variacoesComErro.includes(item.id)
                                        ? '1px solid red'
                                        : 'none',
                                    }}
                                  >
                                    <td>
                                      <span className={styles.variationName}>
                                        <img
                                          src={
                                            item.img
                                              ? typeof item.img === 'string'
                                                ? item.img
                                                : item.img instanceof File
                                                ? URL.createObjectURL(item.img)
                                                : 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/card-image.svg'
                                              : 'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/icons/card-image.svg'
                                          }
                                          alt={item.nome}
                                          className={styles.variationImg}
                                          onClick={() => {
                                            setVariacaoSelecionada(item)
                                            setShowEditVariacao(true)
                                          }}
                                          style={{cursor: 'pointer'}}
                                        />
                                        {item.name}
                                      </span>
                                    </td>
                                    <td>{item.sku}</td>
                                    <td>
                                      <div style={{width: 60}}>
                                        <input
                                          type='text'
                                          value={item.inventory}
                                          className={styles.variationInput}
                                          onChange={(e) => {
                                            setVariacoesTabela((prev) =>
                                              prev.map((v) =>
                                                v.id === item.id
                                                  ? {...v, inventory: e.target.value}
                                                  : v
                                              )
                                            )
                                          }}
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div style={{width: 100}}>
                                        <Input
                                          inputAttr={{
                                            type: 'money',
                                          }}
                                          currency='BRL'
                                          locale='pt-BR'
                                          change={(e: any) => {
                                            setVariacoesTabela((prev) =>
                                              prev.map((v) =>
                                                v.id === item.id ? {...v, price: e} : v
                                              )
                                            )
                                            if (e) {
                                              setVariacoesComErro((prev) =>
                                                prev.filter((id) => id !== item.id)
                                              )
                                            }
                                          }}
                                          value={item.price}
                                          marginTop='mt-0'
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <label className={styles.switch}>
                                        <input
                                          type='checkbox'
                                          checked={item.status}
                                          onChange={(e) => {
                                            setVariacoesTabela((prev) =>
                                              prev.map((v) =>
                                                v.id === item.id
                                                  ? {...v, status: e.target.checked}
                                                  : v
                                              )
                                            )
                                          }}
                                        />
                                        <span className={styles.slider}></span>
                                      </label>
                                    </td>
                                    <td>
                                      <button
                                        onClick={() => {
                                          setVariacaoSelecionada(item)
                                          setShowEditVariacao(true)
                                        }}
                                        className={styles.actionBtn}
                                        title='Editar Variação'
                                        style={{cursor: 'pointer'}}
                                      >
                                        <i className='fas fa-pen'></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className='card mt-8'>
              <div className='px-10 py-5'>
                <div className='d-flex justify-content-between w-100 mt-8'>
                  <Button
                    text={i18n.t(`buttons.back`)}
                    color='info'
                    size='small'
                    horizontalPadding={5}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      navigate(
                        `${
                          loginInfo.plugintype === 'varejo' ? '/product_varejo' : '/product_fashion'
                        }`
                      )
                    }}
                    btnClass='fw-bolder me-3'
                  />
                  <Button
                    text={i18n.t(`general.edit`)}
                    color='primary'
                    size='small'
                    horizontalPadding={5}
                    btnAttr={{
                      type: 'button',
                    }}
                    click={() => {
                      setCanAlert(false)
                      // Se é produto simples, chama editProduct diretamente
                      // Se tem variações, chama checkVariations que valida e chama as funções necessárias
                      isSimpleProduct ? editProduct() : checkVariations()
                    }}
                    btnClass='fw-bolder'
                  />
                </div>
              </div>
            </div>
          </div>

          {showVariacoesModal && (
            <IndexGrade
              onCloseAction={() => {
                setShowVariacoesModal(false)
                setSelectedGradeToEdit(null)
              }}
              title='Adicionar Grades'
              grids={grids}
              gradeSelected={gradeSelected}
              setGradeSelected={setGradeSelected}
              editGradeAgain={editGradeAgain}
              editPageProduct={true}
            />
          )}
          {showEditVariacao && (
            <EditVariacao
              onCloseAction={() => {
                setShowEditVariacao(false)
                setVariacaoSelecionada(null)
              }}
              title='Editar Variação'
              item={variacaoSelecionada}
              onSave={handleSaveVariacao}
              formatSize={formatSize}
              locations={locations}
              setVariacoesComErro={setVariacoesComErro}
              skuEdit={false}
              hasERP={hasERP}
            />
          )}
          <Notification
            message={notification.message}
            type={notification.type}
            show={notification.show}
            onClose={() => setNotification((prev) => ({...prev, show: false}))}
          />
        </>
      )}

      {/* Modal IA Descrição Avançada */}
      {showDescriptionIAModal && (
        <ModalWrapper
          confirmAction={() => setShowDescriptionIAModal(false)}
          noCloseOverlay={true}
          noCloseButton={true}
          noAction={true}
          width={70}
          maxWidth
        >
          <ContentModalDescriptionIA
            description={description}
            productName={name}
            productImage={
              filesProduto?.[0]
                ? 'path' in filesProduto[0]
                  ? filesProduto[0].path
                  : URL.createObjectURL(filesProduto[0])
                : null
            }
            pluginIA={pluginIA}
            onDescriptionGenerated={(generatedDescription: string) => {
              setDescription(generatedDescription)
              setShowDescriptionIAModal(false)

              // Notificação de sucesso
              Swal.fire({
                icon: 'success',
                title: 'Descrição gerada!',
                text: 'A descrição foi gerada com sucesso pela IA.',
                timer: 2000,
                showConfirmButton: false,
              })
            }}
            onCancel={() => setShowDescriptionIAModal(false)}
          />
        </ModalWrapper>
      )}
    </>
  )
}

const NewEditarProdutos: FC = () => {
  const {loginInfo} = useAuth()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {
            title: i18n.t(`smart_order.product`),
            path: loginInfo.plugintype === 'varejo' ? 'product_varejo' : 'product_fashion',
            isActive: true,
          },
          {
            title: i18n.t(`buttons.edit`),
            path:
              loginInfo.plugintype === 'varejo' ? 'product_varejo/criar' : 'product_fashion/criar',
            isActive: true,
          },
        ]}
      >
        {`${i18n.t(`buttons.edit`)} ${i18n.t(`smart_order.product`)}`}
      </PageTitle>
      <NewEditarProdutosContent />
    </>
  )
}

export {NewEditarProdutos}
